module.exports = __webpack_public_path__ + "static/media/exchange-report.be9e729a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/exchange-report.svg
// module id = 1124
// module chunks = 1